import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import CustomBudgetBreakdownCode from '@/presentation/components/custom-products/custom-budget-breakdown/custom-budget-breakdown.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new CustomBudgetBreakdownCode();

		return {
			isLoading: code.isLoading,
			budgetCustom: code.budgetCustom,
			budgetUsed: code.budgetUsed,
			budgetLeft: code.budgetLeft,
			wereCustomProductsModified: code.wereCustomProductsModified
		};
	}
});
